import {shouldUseProvisionalTaskTitle} from '@github-ui/agent-sessions/utils/task-helpers'
import {setTitle} from '@github-ui/document-metadata'
import type {MainQueryResult} from '@github-ui/react-core/future/main-query'
import type {QueryClient, QueryKey} from '@github-ui/react-query'

export function setCopilotDocumentTitle(queryClient: QueryClient, queryKey: QueryKey, name?: string) {
  const title = shouldUseProvisionalTaskTitle(name) ? 'GitHub Copilot' : `${name} · GitHub Copilot`
  const cached = queryClient.getQueryData<MainQueryResult<unknown>>(queryKey)
  if (cached && cached.meta?.title !== title) {
    queryClient
      .getQueryCache()
      .find({queryKey, exact: true})
      ?.setState({
        data: {...cached, meta: {...cached.meta, title}},
      })
  }
  setTitle(title)
}
